/// <amd-module name="Reporting/CFDReport/Pickers/SwimlanePickerOptions" />
import { BoardSwimlane, BoardSwimlaneQuery } from "Analytics/Boards/CumulativeFlowDiagramQueries/BoardSwimlaneQuery";
import { ICacheableQueryService } from "Dashboards/WidgetCommon/DashboardsCacheableQueryService";
import { IVssPageContext } from "VSS/Platform/Context";
import { reportCommand } from "Widgets/CumulativeFlowDiagram/QueryUtilities";
export { BoardSwimlane };
import * as Resources from "Reporting/CFDReport/Resources";
import { format } from "VSS/Core/Util/String";
import { IListBoxItem } from "VSSUI/ListBox";

export async function getSwimlanes(pageContext: IVssPageContext, projectId: string, boardId: string): Promise<IListBoxItem<BoardSwimlane>[]> {
    const queryCache = pageContext.getService<ICacheableQueryService>("IDashboardsCacheableQueryService");
    const query = new BoardSwimlaneQuery(reportCommand, projectId, boardId);
    const result = await queryCache.getCacheableQueryResult(query);
    const defaultNameOfDefaultLane = "(Default Lane)"; // The default name of the default lane, as replicated from legacy implementation

    let mappedResult: IListBoxItem<BoardSwimlane | undefined>[] = result.map(lane => {
        const name =
            lane.IsDefaultLane && lane.LaneName !== defaultNameOfDefaultLane ? format(Resources.DefaultBoardLaneName, lane.LaneName) : lane.LaneName;

        return {
            id: lane.LaneId,
            text: name,
            data: lane
        };
    });

    mappedResult = mappedResult.sort(swimlanesSortCompareFn);

    // Define an artificial "All" lane. CFD widget has special treatment for this non-existent lane.
    mappedResult.unshift({
        id: "All",
        text: Resources.AllBoardLanesName,
        data: {
            IsDefaultLane: false,
            LaneId: (null as unknown) as string,
            LaneName: (null as unknown) as string,
            LaneOrder: 0
        }
    });
    // @ts-ignore TypeScript 3.5 update
    return mappedResult;
}
/** Locates the appropriate Swimlane, on basis of supplied lane name. In the absence of the lane default lane is  returned */
export function lookupLane(swimlanes: IListBoxItem<BoardSwimlane>[], laneName: string | null): IListBoxItem<BoardSwimlane> {
    let selectedSwimLane =
        swimlanes[
            swimlanes.findIndex(lane => {
                return lane.data !== undefined && lane.data.LaneName === laneName;
            })
        ];

    if (selectedSwimLane == null) {
        selectedSwimLane = lookupDefaultLane(swimlanes);
    }

    return selectedSwimLane;
}

/**returns the default swimlane */
export function lookupDefaultLane(swimlanes: IListBoxItem<BoardSwimlane>[]): IListBoxItem<BoardSwimlane> {
    return swimlanes[
        swimlanes.findIndex(lane => {
            return lane.data !== undefined && lane.data.IsDefaultLane;
        })
    ];
}

/**
 * Used to order the swimlanes by default lane first, then by ascending lane order, for consistency with Widget Swimlane picker.
 * @param a - The first swimlane
 * @param b - The second swimlane
 * @returns A negative number if 'a' comes before 'b', a positive number if 'b' comes before 'a'.
 */
function swimlanesSortCompareFn(a: IListBoxItem<BoardSwimlane>, b: IListBoxItem<BoardSwimlane>): number {
    if (a.data!.IsDefaultLane) {
        return -1;
    } else if (b.data!.IsDefaultLane) {
        return 1;
    } else {
        return a.data!.LaneOrder - b.data!.LaneOrder;
    }
}
